module.exports = __webpack_public_path__ + "8104df7bf25a02de5658ba2bc2590b9d.svg";